import CVUpload from "@/components/cv-upload"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog"
import { closePopup, openPopup } from "@/store/features/cvUpload/cvUploadSlice"
import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { Plus } from "lucide-react"

export function AddCVButton() {
  const { isPopupOpen } = useAppSelector((state) => state.cvUpload)
  const dispatch = useAppDispatch()

  return (
    <Dialog open={isPopupOpen} onOpenChange={() => isPopupOpen ? dispatch(closePopup()) : dispatch(openPopup())}>
      <DialogTrigger asChild>
        <Button className="flex gap-2">
          <Plus size={16} />
          <span>Add CV</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-6xl" onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>Upload New CV</DialogTitle>
          <DialogDescription>
            Upload a candidate's CV to add them to the talent pool
          </DialogDescription>
        </DialogHeader>
        <CVUpload />
      </DialogContent>
    </Dialog>
  )
} 